import { TFunction } from 'i18next'

import ProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'
import { ContentfulSizeChart } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

export const TAB_CONFIG = {
  sizeChart: {
    tabTitle: 'size_chart',
    tabId: 'size-chart',
  },
  measuringGuide: {
    tabTitle: 'measuring_guide',
    tabId: 'measuring-guide',
  },
}

export interface SizeGuideTab {
  tabTitle: string
  tabId: string
  sizeChart: ContentfulSizeChart | null
  measuringGuides: ProductMeasuringGuide[]
}

export const getSizeGuideTabs = ({
  sizeChart,
  measuringGuides,
  t,
}: {
  sizeChart: ContentfulSizeChart
  measuringGuides?: ProductMeasuringGuide[]
  t: TFunction<'common'>
}): SizeGuideTab[] => {
  if (!sizeChart) return []

  if (measuringGuides && measuringGuides?.length > 1) {
    const tabs = [
      {
        tabTitle: t(TAB_CONFIG.sizeChart.tabTitle),
        tabId: TAB_CONFIG.sizeChart.tabId,
        sizeChart: sizeChart,
        measuringGuides: [], // If multiple measuring guides, dont show measuring guide on size tab
      },
      {
        tabTitle: t(TAB_CONFIG.measuringGuide.tabTitle),
        tabId: TAB_CONFIG.measuringGuide.tabId,
        measuringGuides: measuringGuides,
        sizeChart: null,
      },
    ]

    return tabs
  }

  return [
    {
      tabTitle: t(TAB_CONFIG.sizeChart.tabTitle),
      tabId: TAB_CONFIG.sizeChart.tabId,
      sizeChart: sizeChart,
      measuringGuides: measuringGuides?.slice(0, 1) ?? [],
    },
  ]
}
